import { modals } from "@mantine/modals";
import DataTable from "../components/common/DataTable";
import { Button, Image, Group, Modal, Select, Stack } from "@mantine/core";
import { notifications } from "@mantine/notifications";

import React, { useEffect } from "react";
import useSearch from "../components/common/Search";
import {
  addDatatoRent,
  getAllMovies,
  getAllSeries,
  getAllUserRent,
  getAllUsers,
} from "../utils/api";
const Rent = () => {
  const [users, setUsers] = React.useState([]);
  const [updateDetails, setUpdateDetails] = React.useState({});
  const [dataH, setData] = React.useState([]);

  const getAllUsersHandler = async () => {
    const [success, data] = await getAllUsers();
    if (success) {
      setUsers(data);
    }
  };
  
  const [open, setOpen] = React.useState(false);
  const [open2, setOpen2] = React.useState(false);

  const getallMovies = async () => {
    const [success, data] = await getAllMovies();
    if (success) {
      setData(data);
    }
  };
  const search = useSearch();
  const getallSeries = async () => {
    const [success, data] = await getAllSeries();
    if (success) {
      setData(data);
    }
  };

  const addRented = async () => {
    if (updateDetails.type && updateDetails.itemId && updateDetails.userId) {
      const formData = {
        userId: updateDetails.userId,
        type: updateDetails.type,
        [updateDetails.type === "Movie" ? "movieId" : "seriesId"]:
          updateDetails.itemId,
      };

      const [success, data] = await addDatatoRent(formData);
      if (success) {
        notifications.show({ message: "Rented successfully", color: "green" });
        setOpen2(false);
      } else {
        notifications.show({ message: "Rented error", color: "red" });
      }
    } else {
      notifications.show({ message: "Rented error", color: "red" });
    }
  };

  useEffect(() => {
    if (updateDetails.type === "Movie") {
      getallMovies();
    }
    if (updateDetails.type === "Series") {
      getallSeries();
    }
  }, [updateDetails.type]);

  useEffect(() => {
    getAllUsersHandler();
  }, []);

  return (
    <div>
      <DataTable
        dataSource={users}
        //   head={["Image", "name", "email", "PhoneNumber", "Rented", "Actions"]}
        //   rows={(user) => (
        //     <>
        //       <Td>
        //         <Image
        //           src={user.image}
        //           alt={user.name}
        //           sx={{
        //             width: "50px",
        //             height: "50px",
        //             borderRadius: "50%",
        //           }}
        //         />
        //       </Td>

        //       <Td>{user.name}</Td>
        //       <Td>{user.email}</Td>
        //       <Td>{user.phoneNumber}</Td>
        //       <Td>
        //         <Button
        //           colorScheme={"blue"}
        //           onClick={() => {
        //             getallrents(user._id);
        //             onOpen();
        //           }}
        //         >
        //           View
        //         </Button>
        //       </Td>
        //       <Td>
        //         <Button
        //           colorScheme={"blue"}
        //           onClick={() => {
        //             setUpdateDetails((prev) => ({ ...prev, userId: user._id }));
        //             onOpen2();
        //           }}
        //         >
        //           Add
        //         </Button>
        //       </Td>
        //     </>
        //   )}

        columns={[
          {
            title: "Image",
            dataIndex: "image",
            key: "image",
            render: (text) => <Image src={text} alt="image" width={50} />,
          },
          {
            title: "Name",
            dataIndex: "name",
            key: "name",
            ...search("name"),
          },
          {
            title: "Email",
            dataIndex: "email",
            key: "email",
          },
          {
            title: "Phone Number",
            dataIndex: "phoneNumber",
            key: "phoneNumber",
          },
          {
            title: "Rented",
            dataIndex: "rented",
            key: "rented",
            render: (text, record) => (
              <Button
                onClick={async () => {
                  const [success, data] = await getAllUserRent(record._id);

                  modals.open({
                    title: "Rented",
                    size: "xl",
                    children: (
                      <DataTable
                        dataSource={data?.rentedContent}
                        columns={[
                          {
                            title: "Image",
                            dataIndex: "item",
                            key: "item",
                            render: (text) => (
                              <Image
                                src={text?.horizontalBanner}
                                alt="image"
                                width={50}
                              />
                            ),
                          },
                          {
                            title: "Name",
                            dataIndex: "item",
                            key: "itemName",
                            render: (text) => <p>{text?.name}</p>,
                          },
                          {
                            title: "Expire Date",
                            dataIndex: "expireDate",
                            key: "expireDate",
                          },
                        ]}
                      />
                    ),
                  });
                }}
              >
                View
              </Button>
            ),
          },
          {
            title: "Actions",
            dataIndex: "actions",
            key: "actions",
            render: (text, record) => (
              <Button
                onClick={() => {
                  setUpdateDetails((prev) => ({ ...prev, userId: record._id }));
                  setOpen2(true);
                }}
              >
                Add
              </Button>
            ),
          },
        ]}
      />

      <Modal
        title="Add Rent"
        opened={open2}
        onClose={() => setOpen2(false)}
        footer={
          <Group justify="flex-end" mt="md">
            <Button variant="default" onClick={() => setOpen2(false)}>Cancel</Button>
            <Button onClick={addRented}>Add</Button>
          </Group>
        }
      >
        <Stack>
          <Select
            placeholder="Select type"
            data={[
              { label: "Movie", value: "Movie" },
              { label: "Series", value: "Series" },
            ]}
            value={updateDetails.type || null}
            onChange={(val) => setUpdateDetails((prev) => ({ ...prev, type: val }))}
          />
          {updateDetails.type && (
            <Select
              placeholder={`Select ${updateDetails?.type}`}
              value={updateDetails.itemId || null}
              onChange={(val) => setUpdateDetails((prev) => ({ ...prev, itemId: val }))}
              data={dataH.map((item) => ({ label: item.name, value: item._id }))}
            />
          )}
        </Stack>
      </Modal>

      {/* <CreateModal table title="Rented" isOpen={isOpen} onClose={onClose}>
        <CreateTable
          data={rent.rentedContent}
          head={["Image", "name", "Expire Date"]}
          rows={(rented) => (
            <>
              <Td>
                <Image
                  src={rented?.item?.horizontalBanner}
                  alt={rented?.item?.name}
                  sx={{ height: "100px", width: "100px" }}
                />
              </Td>
              <Td>{rented?.item?.name}</Td>
              <Td>{rented?.expireDate}</Td>
            </>
          )}
        />
      </CreateModal>
      <CreateModal
        title="Add Rent"
        isOpen={isOpen2}
        onClose={onClose2}
        create={addRented}
      >
        <Select
          placeholder="Select type"
          onChange={(e) => {
            setUpdateDetails((prev) => ({ ...prev, type: e.target.value }));
          }}
        >
          <option value="Movie">Movie</option>
          <option value="Series">Series</option>
        </Select>
        {updateDetails.type && (
          <Select
            placeholder={`Select ${updateDetails?.type}`}
            onChange={(e) => {
              setUpdateDetails((prev) => ({ ...prev, itemId: e.target.value }));
            }}
          >
            {dataH.map((item) => (
              <option value={item._id}>{item.name}</option>
            ))}
          </Select>
        )}
      </CreateModal> */}
    </div>
  );
};

export default Rent;
